import moment from 'moment-timezone';
import { Cloudinary } from "cloudinary-core";
new Cloudinary({ cloud_name: "dq5nc6lbr" });

export const UploadImage = async (file) => {
    try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", "Emmanuel");
        formData.append("folder", "DevSync");

        const response = await fetch(
            `https://api.cloudinary.com/v1_1/dq5nc6lbr/image/upload`,
            {
                method: "POST",
                body: formData,
            }
        );

        const data = await response.json();
console.log(data)
        return data.secure_url; // This is the URL of the uploaded image
    } catch (error) { handleAuthError(error)
        console.error("Error uploading image:", error);
    }
};

export function slugify(str) {
  str = str.replace(/^\s+|\s+$/g, ''); // trim leading/trailing white space
  str = str.toLowerCase(); // convert string to lowercase
  str = str.replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
           .replace(/\s+/g, '-') // replace spaces with hyphens
           .replace(/-+/g, '-'); // remove consecutive hyphens
  return str;
}

export const totalCohortChild = (programs, id) => {
  const filteredPrograms = programs.filter((program) => program.partnerId === id);
  const programCount = filteredPrograms.reduce((count, program) => {
    const childId = program.childId;
    if (!count.has(childId)) {
      count.set(childId, 1);
    }
    return count;
  }, new Map());

  return programCount.size
};


export const totalCohortParent = (programs, id) => {
  const filteredPrograms = programs.filter((program) => program.partnerId === id);
  const programCount = filteredPrograms.reduce((count, program) => {
    const parentId = program.child.parentId;
    if (!count.has(parentId)) {
      count.set(parentId, 1);
    }
    return count;
  }, new Map());

  return programCount.size
};


export function newFormatDate(dateString) {
  const date = new Date(dateString);
  const day = String(date.getUTCDate()).padStart(2, '0'); // Get day and pad with zero if needed
  const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Get month (0-indexed) and pad
  const year = date.getUTCFullYear(); // Get full year

  return `${day}/${month}/${year}`; // Format as DD/MM/YYYY
}

export function calculateDebt(programs) {
  const debt = programs.filter((program) => program.partner_package && !program.isPaid)
    .reduce((total, program) => total + program.partner_package.amount, 0);
  return debt
}

export function formatData(data) {
  const parsed = Array.isArray(data)
    ? data
    : JSON.parse(data)
  return parsed
}



export function convertLessonTimes(times, parentTimezone) {
  const defaultTimezone = "Africa/Lagos";

  const convertedTimes = times.map(slot => {
    const time = moment.tz(
      `${slot.timeText} ${slot.dayText}`,
      "hA dddd",
      defaultTimezone
    );

    const convertedTime = defaultTimezone === parentTimezone
      ? time
      : time.clone().tz(parentTimezone);

    return `${convertedTime.format('dddd')} ${convertedTime.format('h:mmA')}`;
  });

  return convertedTimes.join(', ');
}

export function convertSingleLessonTimes(timeText, parentTimezone, customDay) {
  const defaultTimezone = "Africa/Lagos";

  const day = customDay || 'Monday';  // Default to 'Monday' if customDay is not passed

  // Parsing the time and day with the default timezone 'Africa/Lagos'
  const time = moment.tz(
    `${timeText} ${day}`,
    "hA dddd",
    defaultTimezone
  );

  // Convert to parentTimezone if needed, or keep it in default timezone
  const convertedTime = defaultTimezone === parentTimezone
    ? time
    : time.clone().tz(parentTimezone);

  // Return the time formatted as 'h:mmA'
  return convertedTime.format('h:mmA');
}

export function convertSingleLessonTimesProgram(timeText, parentTimezone, customDay) {
  const defaultTimezone = "Africa/Lagos";

  const day = customDay || 'Monday';  // Default to 'Monday' if customDay is not passed

  // Parsing the time and day with the default timezone 'Africa/Lagos'
  const time = moment.tz(
      `${timeText} ${day}`,
      "hA dddd",
      parentTimezone
  );

  // Convert to parentTimezone if needed, or keep it in default timezone
  const convertedTime = time.clone().tz(defaultTimezone);

  // Return the time formatted as 'h:mmA'
  return convertedTime.format('h:mmA');
}

export function convertTimeGroup(times) {
  try {
    let formatted = [];

    if (Array.isArray(times[0]) && Array.isArray(times)) {
      formatted = times.map((slotPair, index) => {
        const [start, end] = slotPair;
        return {
          value: index,
          name: `${start.dayText} ${start.timeText}, ${end.dayText} ${end.timeText}`,
        };
      });
    }

    else if (Array.isArray(times)) {
      formatted = times.map((slot) => ({
        value: slot.id,
        name: `${slot.dayText} ${slot.timeText}`,
      }));
    }

    return formatted;
  } catch (error) { handleAuthError(error)
    console.error('Error parsing time slots:', error);
    return [];
  }
}

export function convertTimegroupToParentTimezone(timegroup, parentTimezone) {

  const defaultTimezone = "Africa/Lagos";

  const timeStrings = timegroup.split('&').map(str => str.trim());

  const convertedTimes = timeStrings.map(timeString => {
    try {
      const match = timeString.match(/([A-Za-z]+ \d+), ([A-Za-z]+) (\d+)(?::(\d+))?([AP]M)/i);
      if (!match) throw new Error('Invalid format');

      const [, datePart, dayPart, hours, minutes = '00', ampm] = match;
      const currentYear = new Date().getFullYear();
      const dateStr = `${datePart} ${currentYear} ${hours}:${minutes} ${ampm}`;

      const time = moment.tz(dateStr, 'MMMM D YYYY h:mm A', defaultTimezone);

      if (!time.isValid()) {
        throw new Error(`Invalid date: ${dateStr}`);
      }

      if (parentTimezone === defaultTimezone) {
        return `${time.format('MMMM D')}, ${dayPart} ${time.format('h:mmA')}`;
      }

      const convertedTime = time.clone().tz(parentTimezone);

      return `${convertedTime.format('MMMM D')}, ${dayPart} ${convertedTime.format('h:mmA')} `;

    } catch (error) { handleAuthError(error)
      return 'Invalid date';
    }
  });

  return convertedTimes.join(' & ');
}


export function transformCoursesToSelectOptions(courses) {
  // Create the "All Levels" option
  const allLevelsOption = {
    value: 0,
    label: "All Levels"
  };

  // Map the courses to select options
  const courseOptions = courses.map(course => ({
    value: course.id,
    label: course.title
  }));

  // Combine them with "All Levels" first
  return [allLevelsOption, ...courseOptions];
}

export function getLabelsForIds(ids, selectOptions) {
  // 1. Parse JSON if needed (handle stringified arrays)
  const parsedIds = typeof ids === 'string' ? JSON.parse(ids) : ids;

  // 2. Handle empty/null cases
  if (!parsedIds || parsedIds.length === 0) return "All Levels";

  // 3. Ensure all IDs are numbers (Sequelize might return strings)
  const numericIds = Array.isArray(parsedIds) 
    ? parsedIds.map(Number) 
    : [Number(parsedIds)];

  // 4. Map IDs to labels
  const optionsMap = new Map(
    selectOptions.map(option => [option.value, option.label])
  );

  const labels = numericIds.map(id => 
    optionsMap.get(id) || `Unknown ID: ${id}`
  );

  return labels.join(", ");
}


export function getLevelLabels(levels, packages) {
  // 1. Parse levels if it's a JSON string (Sequelize may return strings)
  const parsedLevels = typeof levels === 'string' 
    ? JSON.parse(levels) 
    : Array.isArray(levels) ? levels : [];

  // 2. Extract unique levels from packages (to avoid duplicates)
  const uniqueLevels = [...new Set(parsedLevels)];

  // 3. Map each level to its corresponding package title(s)
  return uniqueLevels.map(level => {
    // Find the first matching package (or use a fallback)
    const matchingPackage = packages.find(pkg => pkg.level === level);
    return {
      value: level,  // The level number (2,7,8...)
      label: matchingPackage 
        ? matchingPackage.title 
        : `Level ${level} (Not Found)` // Fallback if no match
    };
  });
}
   export const convertLessonTimesProgram = (time, timezone, day) => {
        if (!time || !timezone || day === undefined) return '';
        
        // Get the time in format "HH:MMAM/PM" (e.g., "8:00AM")
        const timeStr = formatTime(time);
        
        try {
          // Parse the time string into hours and minutes
          const [timePart, period] = timeStr.match(/(\d+):(\d+)([AP]M)/).slice(1);
          let hours = parseInt(timePart, 10);
          const minutes = parseInt(period, 10);
          
          // Convert to 24-hour format
          if (period === 'PM' && hours !== 12) {
            hours += 12;
          } else if (period === 'AM' && hours === 12) {
            hours = 0;
          }
          
          // Create a moment object in the program's timezone (UTC)
          const programTime = moment().utc()
            .day(day)
            .hour(hours)
            .minute(minutes)
            .second(0);
          
          // Convert to parent's timezone
          const parentTime = programTime.clone().tz(timezone);
          
          // Format the time in 12-hour format with AM/PM
          return parentTime.format('h:mmA');
          
        } catch (error) { handleAuthError(error)
          console.error('Error converting lesson time:', error);
          return timeStr; // Return original time if conversion fails
        }
      };

export const handleAuthError = (error) => {
  const status = error.response?.status;
  if (status === 401 || status === 403) {
    localStorage.clear();
    window.location.assign('/auth/logout');
  }
};